export const LOGIN_SUCCESS = '[Core/Auth] LOGIN_SUCCESS';
export const REGISTER_NEW_USER_PENDING = '[Core]/REGISTER_NEW_USER_PENDING';
export const REGISTER_NEW_USER_SUCCESS = '[Core]/REGISTER_NEW_USER_SUCCESS';
export const REGISTER_NEW_USER_ERROR = '[Core]/REGISTER_NEW_USER_ERROR';
export const INIT = '[Core/Auth] INIT';

export const CHANGE_REGISTRATION_STATUS = '[Core/Auth]/CHANGE_REGISTRATION_STATUS';
